// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2714":"3c814eb6","5295":"5dc91bd0"}[chunkId] + ".chunk.css";
};